import React, { SVGProps } from "react";

export const Sort = ({
  fill = "#000000",
  width = 64,
  height = 64,
}: SVGProps<{}>) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {" "}
      <path
        d="M10.5 8.24994C10.31 8.24994 10.12 8.17994 9.97 8.02994L8 6.05994L6.03 8.02994C5.74 8.31994 5.26 8.31994 4.97 8.02994C4.68 7.73994 4.68 7.25994 4.97 6.96994L7.47 4.46994C7.76 4.17994 8.24 4.17994 8.53 4.46994L11.03 6.96994C11.32 7.25994 11.32 7.73994 11.03 8.02994C10.88 8.17994 10.69 8.24994 10.5 8.24994Z"
        fill={fill}
      ></path>{" "}
      <path
        d="M8 19.75C7.59 19.75 7.25 19.41 7.25 19V5C7.25 4.59 7.59 4.25 8 4.25C8.41 4.25 8.75 4.59 8.75 5V19C8.75 19.41 8.41 19.75 8 19.75Z"
        fill={fill}
      ></path>{" "}
      <path
        d="M16 19.7499C15.81 19.7499 15.62 19.6799 15.47 19.5299L12.97 17.0299C12.68 16.7399 12.68 16.2599 12.97 15.9699C13.26 15.6799 13.74 15.6799 14.03 15.9699L16 17.9399L17.97 15.9699C18.26 15.6799 18.74 15.6799 19.03 15.9699C19.32 16.2599 19.32 16.7399 19.03 17.0299L16.53 19.5299C16.38 19.6799 16.19 19.7499 16 19.7499Z"
        fill={fill}
      ></path>{" "}
      <path
        d="M16 19.75C15.59 19.75 15.25 19.41 15.25 19V5C15.25 4.59 15.59 4.25 16 4.25C16.41 4.25 16.75 4.59 16.75 5V19C16.75 19.41 16.41 19.75 16 19.75Z"
        fill={fill}
      ></path>{" "}
    </g>
  </svg>
);

// eslint-disable-next-line import/no-default-export
export default Sort;
